<div class="inspector-view">
  <div class="main-content">
    <div class="video-section">
      <div #inspectorVideoContainer class="video-container">
        <video
          #inspectorLocalVideo
          preload="metadata"
          autoplay
          style="display: none"
        ></video>
        
        <!-- Coordinator Video Postage Stamp -->
        <div #coordinatorVideoContainer class="coordinator-postage-stamp" *ngIf="coordinatorVideoAvailable">
          <!-- Coordinator video will be attached here -->
        </div>

        <!-- Network Quality Indicator -->
        <app-network-quality-indicator
          class="network-quality-overlay"
          [quality]="networkQuality"
          [trend]="networkTrend"
          [latency]="networkLatency">
        </app-network-quality-indicator>

        <!-- Fullscreen Toggle Button -->
        <button 
          pButton 
          type="button" 
          [icon]="isFullscreen ? 'pi pi-window-minimize' : 'pi pi-window-maximize'" 
          class="fullscreen-btn"
          (click)="toggleFullscreen()"
          [pTooltip]="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
          tooltipPosition="bottom">
        </button>
        
        <!-- Floating Action Buttons -->
        <div class="floating-actions">
          <button 
            pButton 
            type="button" 
            icon="pi pi-camera" 
            class="floating-btn capture-btn"
            (click)="capturePhoto()"
            pTooltip="Take Photo"
            tooltipPosition="left">
          </button>
          <button 
            pButton 
            type="button" 
            icon="pi pi-microphone" 
            class="floating-btn audio-btn"
            [ngClass]="{'active': audioEnabled}"
            (click)="toggleAudio()"
            pTooltip="Toggle Audio"
            tooltipPosition="left">
          </button>
          <button 
            pButton 
            type="button" 
            icon="pi pi-video" 
            class="floating-btn video-btn"
            [ngClass]="{'active': videoEnabled}"
            (click)="toggleVideo()"
            pTooltip="Toggle Video"
            tooltipPosition="left">
          </button>
          <button 
            *ngIf="!videoEnabled"
            pButton 
            type="button" 
            icon="pi pi-play" 
            class="floating-btn start-btn"
            (click)="startVideo($event)"
            pTooltip="Start Video"
            tooltipPosition="left">
          </button>
          <button 
            *ngIf="videoEnabled"
            pButton 
            type="button" 
            icon="pi pi-comments" 
            class="floating-btn chat-btn"
            [ngClass]="{'active': showChat}"
            (click)="toggleChat()"
            pTooltip="Toggle Chat"
            tooltipPosition="left">
            <span class="action-badge" *ngIf="((chatService.unreadCount$ | async) || 0) > 0 && !showChat">
              {{ (chatService.unreadCount$ | async) || 0 }}
            </span>
          </button>
          <button 
            pButton 
            type="button" 
            icon="pi pi-stop" 
            class="floating-btn end-btn"
            (click)="endSession()"
            pTooltip="End Session"
            tooltipPosition="left">
          </button>
        </div>
        
        <!-- Chat Component -->
        <app-chat *ngIf="videoEnabled && showChat"></app-chat>
      </div>
    </div>
  </div>
  
  <!-- Photo Thumbnails Footer -->
  <div class="photo-footer" *ngIf="(sessionMedia$ | async)?.length">
    <div class="photo-thumbnails-container">
      <div 
        *ngFor="let photo of (sessionMedia$ | async); let i = index; trackBy: trackByPhotoId" 
        class="photo-thumbnail"
        (click)="openPhotoPreview(i)">
        <div class="photo-badge">{{ getPhotoBadgeNumber(photo, i) }}</div>
        <img 
          [src]="getPhotoThumbnailUrl(photo)" 
          [alt]="'Photo ' + (i + 1)"
          class="thumbnail-image"
          loading="lazy">
      </div>
    </div>
  </div>
  
  <!-- Full Size Photo Preview Modal -->
  <div class="photo-preview-modal" *ngIf="showPhotoPreview && getSelectedPhoto()" (click)="closePhotoPreview()">
    <div class="photo-preview-content" (click)="$event.stopPropagation()">
      <div class="photo-preview-header">
        <h3>Photo {{ getPhotoBadgeNumber(getSelectedPhoto()!, selectedPhotoIndex) }} of {{ currentPhotos.length }}</h3>
        <button class="close-btn" (click)="closePhotoPreview()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="photo-preview-image">
        <img 
          *ngIf="getSelectedPhoto()"
          [src]="getPhotoFullUrl(getSelectedPhoto())" 
          [alt]="'Photo ' + getPhotoBadgeNumber(getSelectedPhoto()!, selectedPhotoIndex)"
          class="preview-image"
          (error)="onPhotoLoadError($event)"
          (load)="onPhotoLoadSuccess($event)">
        <div class="loading-placeholder" *ngIf="!getSelectedPhoto()">
          <i class="pi pi-image"></i>
          <p>Loading photo...</p>
        </div>
      </div>
      <div class="photo-preview-navigation">
        <button 
          pButton 
          type="button" 
          icon="pi pi-chevron-left" 
          (click)="previousPhoto(); $event.stopPropagation()"
          [disabled]="selectedPhotoIndex === 0"
          class="nav-btn">
        </button>
        <button 
          pButton 
          type="button" 
          icon="pi pi-chevron-right" 
          (click)="nextPhoto(); $event.stopPropagation()"
          [disabled]="selectedPhotoIndex === currentPhotos.length - 1"
          class="nav-btn">
        </button>
      </div>
    </div>
  </div>
</div>
